/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeComponentGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Component Group Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const COMPONENTGROUP_LIST_CONTAINER_LOADED = 'COMPONENTGROUP_LIST_CONTAINER_LOADED';
export const COMPONENTGROUP_LIST_CONTAINER_UNLOADED = 'COMPONENTGROUP_LIST_CONTAINER_UNLOADED';

export const COMPONENTGROUP_LIST_TABLE_LOADED = 'COMPONENTGROUP_LIST_TABLE_LOADED';
export const COMPONENTGROUP_LIST_TABLE_UNLOADED = 'COMPONENTGROUP_LIST_TABLE_UNLOADED';

export const COMPONENTGROUP_SELECT_ROW = 'COMPONENTGROUP_SELECT_ROW';
export const COMPONENTGROUP_ADD = 'COMPONENTGROUP_ADD';
export const COMPONENTGROUP_EDIT = 'COMPONENTGROUP_EDIT';
export const COMPONENTGROUP_DELETE = 'COMPONENTGROUP_DELETE';
export const COMPONENTGROUP_DELETE_DISABLE = 'COMPONENTGROUP_DELETE_DISABLE';
export const COMPONENTGROUP_OPEN_WARNING = 'COMPONENTGROUP_OPEN_WARNING';
export const COMPONENTGROUP_CLOSE_WARNING = 'COMPONENTGROUP_CLOSE_WARNING';
export const COMPONENTGROUP_VIEW_COMPONENTS = 'COMPONENTGROUP_VIEW_COMPONENTS';

export const COMPONENTGROUP_EDIT_CONTAINER_LOADED = 'COMPONENTGROUP_EDIT_CONTAINER_LOADED';
export const COMPONENTGROUP_EDIT_CONTAINER_UNLOADED = 'COMPONENTGROUP_EDIT_CONTAINER_UNLOADED';
export const COMPONENTGROUP_EDIT_FORM_LOADED = 'COMPONENTGROUP_EDIT_FORM_LOADED';
export const COMPONENTGROUP_EDIT_FORM_UNLOADED = 'COMPONENTGROUP_EDIT_FORM_UNLOADED';
export const COMPONENTGROUP_EDIT_DATA_LOAD = 'COMPONENTGROUP_EDIT_DATA_LOAD';
export const COMPONENTGROUP_EDIT_CONTAINER_SUBMIT = 'COMPONENTGROUP_EDIT_CONTAINER_SUBMIT';
export const COMPONENTGROUP_EDIT_CONTAINER_CANCEL = 'COMPONENTGROUP_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeComponentGroups.js